import * as yup from "yup";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { OrganizationSelector } from "./OrganizationSelector";
import { PolicyGroups } from "@constants/Policies";
import FeaturesSelector from "./FeatureSelector";
import { UserSelectorAutocomplete } from "./UserSelector";
export const AddFeatureFormInitialValues = {
    organizationId: "",
    action: Object.values(PolicyGroups.FEATURE_GATING),
    //@ts-ignore
    userIds: [],
};
export const AddFeatureFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        action: yup
            .array()
            .min(1, intl.formatMessage(messages.featureActionRequired))
            .required(intl.formatMessage(messages.featureActionRequired)),
        organizationId: yup.string().required(intl.formatMessage(messages.featureOrganizationRequired)),
    });
};
export const AddFeatureFormFields = () => {
    const intl = useIntl();
    return {
        actions: [
            {
                id: "action",
                label: intl.formatMessage(messages.featureAction),
                placeholder: intl.formatMessage(messages.featureAction),
                component: FeaturesSelector,
                required: true,
                columns: 12,
            },
        ],
        organizationId: [
            {
                id: "organizationId",
                label: intl.formatMessage(messages.featureOrganization),
                placeholder: intl.formatMessage(messages.featureOrganization),
                component: OrganizationSelector,
                required: true,
                columns: 12,
            },
        ],
        users: [
            {
                id: "userIds",
                label: intl.formatMessage(messages.featureUser),
                placeholder: intl.formatMessage(messages.featureUser),
                component: UserSelectorAutocomplete,
                columns: 12,
                required: false,
            },
        ],
    };
};
